import railyApiService from "../raily-api.service";
import planEntryActiveListRequestFactory from "./active-list/plan-entry-active-list-request.factory";
import PlanEntryActiveListRequest, {
  PlanEntryActiveListRequestQueryParams,
} from "./active-list/plan-entry-active-list.request";
import PlanEntryActiveListResponse from "./active-list/plan-entry-active-list.response";
import PlanEntryDetailsRequest from "./details/plan-entry-details.request";
import PlanEntryDetailsResponse from "./details/plan-entry-details.response";
import planEntryFinishedListRequestFactory from "./finished-list/plan-entry-finished-list-request.factory";
import PlanEntryFinishedListRequest, {
  PlanEntryFinishedListRequestQueryParams,
} from "./finished-list/plan-entry-finished-list.request";
import PlanEntryFinishedListResponse from "./finished-list/plan-entry-finished-list.response";

const planEntryApiService = () => {
  const getPlanEntryDetails = (
    request: PlanEntryDetailsRequest,
    abortSignal: AbortSignal,
  ): Promise<PlanEntryDetailsResponse> => {
    const url = `/plan-entries/${request.planEntryUuid}`;

    return railyApiService().get<PlanEntryDetailsResponse>({
      url,
      abortSignal,
    });
  };

  const getActiveList = async (
    request: PlanEntryActiveListRequest,
    abortSignal: AbortSignal,
  ): Promise<PlanEntryActiveListResponse> => {
    const url = `/plan-entries/active`;

    const queryParams: PlanEntryActiveListRequestQueryParams =
      planEntryActiveListRequestFactory.createQueryParams(request);

    return railyApiService().get<PlanEntryActiveListResponse>({
      url,
      queryParams,
      abortSignal,
    });
  };

  const getFinishedList = async (
    request: PlanEntryFinishedListRequest,
    abortSignal: AbortSignal,
  ): Promise<PlanEntryFinishedListResponse> => {
    const url = `/plan-entries/finished`;

    const queryParams: PlanEntryFinishedListRequestQueryParams =
      planEntryFinishedListRequestFactory.createQueryParams(request);

    return railyApiService().get<PlanEntryFinishedListResponse>({
      url,
      queryParams,
      abortSignal,
    });
  };

  return {
    getPlanEntryDetails,
    getActiveList,
    getFinishedList,
  };
};

export default planEntryApiService;
